/**
 * CUSTOM ROOM LOADING TO MANAGE LOADING SCREEN.
 * Avoids having to manually reset all data in room.js Vuex file.
 * Meanwhile when exiting room or otherwise resetting room, these
 * states can remain independent.
 */

const getDefaultState = () => {
  return {
    /* CORE ROOM STATE */
    loading: true,
    leaving: false,
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  /* CORE ROOM STATE */
  RESET_ROOM(state) {
    Object.assign(state, getDefaultState());
  },

  SET_LOADING_STATE(state, newState) {
    state.loading = newState;
  },

  SET_LEAVING_STATE(state, newState) {
    state.leaving = newState;
  },
};

// Asynchronous
const actions = {
  /* CORE ROOM STATE */
  resetRoom({ commit }) {
    commit("RESET_ROOM");
  },

  setLoadingState({ commit }, newState) {
    commit("SET_LOADING_STATE", newState);
  },

  setLeavingState({ commit }, newState) {
    commit("SET_LEAVING_STATE", newState);
  },
};

const roomLoading = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default roomLoading;
